module.exports = __webpack_public_path__ + "img/waiting.89107872.png";